import React, { useEffect, useState } from 'react'
// import emailConfig from './emailConfigs'
// import emailModals from './emailModals'
// import EMAIL_FORMATS from './emailFormats'
import CONSTANTS from '../../CONSTANTS'
import TestClipboard from './TestClipboard'
// import { replaceContent } from './emailModals'
// import { Dropdown } from 'primereact/dropdown';


const EmailsToClipBoard = (props) => {
    const [user, setUser] = useState({})
    const { form, selectedSpare } = props

    // const { SERVICE_ENGINEER_REPORT_EMAIL } = EMAIL_FORMATS

    // let email = SERVICE_ENGINEER_REPORT_EMAIL

    useEffect(() => {
        let u = localStorage.getItem('user');
        if (u) {
            u = JSON.parse(u);
            setUser(u);
        }
    }, [])

    // const formatData = (email) => {
    //     let replaced = emailModals.replaceContent(email, form, selectedSpare, user)
    //     let keyLessContent = emailModals.removeEmailContectkeys(replaced)

    //     return keyLessContent
    // }

    // const copyToClipboard = async () => {
    //     // let deleted = emailModals.delBlankLines(email)
    //     let formatted = formatData(email)
    //     try {
    //         await navigator.clipboard.writeText(formatted);
    //         alert('Email Content is copied to clipboard');
    //     } catch (err) {
    //         console.error('Failed to copy text: ', err);
    //     }
    // };

    // const renderCopyToClipBoardButton = () => {
    //     return <div className="d-flex pm10 ">
    //         <button
    //             className="btn-round mr-1 btn button-4 btn-sm"
    //             color="info"
    //             type="button"
    //             onClick={copyToClipboard}
    //         >
    //             Copy Email
    //         </button>
    //     </div>
    // }
    const subjects = () => {
        return (
            <div className='subjects'>
                <h2>Subject Lines: Service Reports</h2>
                <p>Kindly use any one of these subject line for email</p>
                <ul>
                    {(form.isMachineOkay? CONSTANTS.subjectLinesOkayService : CONSTANTS.subjectLines).map((item, i) => <li key={i}> {item} <span onClick={() => navigator.clipboard.writeText(item)}>Copy</span></li>)}
                </ul>
            </div>
        )
    }

    return (
        <div>
            {subjects()}
            <div>
                {/* <h3>Email Content</h3> */}
                {/* <textarea value={formatData(email)} readOnly rows={20} cols={80} /> */}
                {/* <textarea  readOnly rows={20} cols={80} >{formatData(email)}</textarea> */}

            </div>
            {/* <div dangerouslySetInnerHTML={{__html:formatData(email)}}></div> */}
            {/* {renderCopyToClipBoardButton()} */}
            <TestClipboard data={{ form, selectedSpare, user }} />

        </div>
    )
}

export default EmailsToClipBoard


